<template>

    <Page>
    
        <ImageAndText 
            animation="zoom"
            src="/protect-logo.png"
            floor-shadow>

            <h2 class="mb-4">Peace of mind for customers, new revenue for the dealership.</h2>

            <ul class="mt-3 list-disc font-semibold text-white/80">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div><span class="text-cyan-400 uppercase">&gt; £315 Profit</span> Per Policy</div>
                    <!-- <div class="opacity-60 font-normal">No cost to the dealership - pure margin.</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Positive ROI from <span class="text-cyan-400 uppercase">month one</span></div>
                    <!-- <div class="opacity-60 font-normal">At just 25% uptake (25 policies) = strong returns.</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Drives Service Retention</div>
                    <!-- <div class="opacity-60 font-normal">Customers must service with you to stay covered.</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Fantastic Upsell For New Cars</div>
                    <!-- <div class="opacity-60 font-normal">Simple add-on at point of sale.</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Covers What The Warranty Doesn't</div>
                    <!-- <div class="opacity-60 font-normal">Tyres, brakes, batteries, windscreens, key fobs.</div> -->
                </li>
            </ul>

        </ImageAndText>

        <KeyMessage animation="push-up" class="2xl:-mx-10 2xl:-mt-4">
            <span class="align-bottom text-cyan-400">
                No lock in contracts or montly subscription fees<br/>just easy revenue and a unique program!
            </span>
        </KeyMessage>

    </Page>

</template>